module.exports = __webpack_public_path__ + "img/self-reliance-logo.bcbd6de0.png";